var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDischargedPatientsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 52,
    fill: "#ACACAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    transform: "translate(-1341 -167)",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1316,
    y: -22,
    width: 1536,
    height: 100,
    rx: 9.94788,
    fill: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.461914,
    width: 52.4507,
    height: 51.8678,
    rx: 25.9339,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0225 10.0773C28.2412 10.599 30.4262 13.6312 29.9035 16.8487C29.3818 20.0662 26.3495 22.2515 23.1321 21.7297C19.9134 21.208 17.7284 18.1757 18.2511 14.9582C18.7728 11.7396 21.8051 9.55455 25.0225 10.0773Z",
    fill: "#C2D6DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.846 32.4864C34.8449 33.0624 34.3774 33.5288 33.8025 33.5311H14.3511C13.7763 33.5288 13.3087 33.0624 13.3076 32.4864C13.3076 28.6387 15.3607 25.0839 18.6922 23.1604C22.0236 21.2361 26.1301 21.2361 29.4615 23.1604C32.7928 25.0837 34.8461 28.6387 34.8461 32.4864H34.846Z",
    fill: "#C2D6DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.8076,
    cy: 33.5,
    r: 9.5,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8076 26C29.6649 26 26.3076 29.3573 26.3076 33.5C26.3076 37.6427 29.6649 41 33.8076 41C37.9503 41 41.3076 37.6427 41.3076 33.5C41.3076 29.3573 37.9503 26 33.8076 26ZM33.8076 28.4C34.3045 28.4 34.7076 28.8031 34.7076 29.3V32.6H38.0076C38.5045 32.6 38.9076 33.0031 38.9076 33.5C38.9076 33.9969 38.5045 34.4 38.0076 34.4H34.7076V37.7C34.7076 38.1969 34.3045 38.6 33.8076 38.6C33.3108 38.6 32.9076 38.1969 32.9076 37.7V34.4H29.6076C29.1108 34.4 28.7076 33.9969 28.7076 33.5C28.7076 33.0031 29.1108 32.6 29.6076 32.6H32.9076V29.3C32.9076 28.8031 33.3108 28.4 33.8076 28.4Z",
    fill: "#9BBCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8076 26C29.6649 26 26.3076 29.3573 26.3076 33.5C26.3076 37.6427 29.6649 41 33.8076 41C37.9503 41 41.3076 37.6427 41.3076 33.5C41.3076 29.3573 37.9503 26 33.8076 26ZM33.8076 28.4C34.3045 28.4 34.7076 28.8031 34.7076 29.3V32.6H38.0076C38.5045 32.6 38.9076 33.0031 38.9076 33.5C38.9076 33.9969 38.5045 34.4 38.0076 34.4H34.7076V37.7C34.7076 38.1969 34.3045 38.6 33.8076 38.6C33.3108 38.6 32.9076 38.1969 32.9076 37.7V34.4H29.6076C29.1108 34.4 28.7076 33.9969 28.7076 33.5C28.7076 33.0031 29.1108 32.6 29.6076 32.6H32.9076V29.3C32.9076 28.8031 33.3108 28.4 33.8076 28.4Z",
    fill: "#9BBCCB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.3076,
    y: 27,
    width: 3,
    height: 12,
    fill: "#9BBCCB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.3076,
    y1: 33.5,
    x2: 38.3076,
    y2: 33.5,
    stroke: "#EBEFF2",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_56220",
    x: -1318,
    y: -22,
    width: 1540,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.307813 0 0 0 0 0.326577 0 0 0 0 0.375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_56220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_56220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    fill: "white",
    transform: "translate(-1341 -167)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDischargedPatientsIcon);
export default __webpack_public_path__ + "static/media/discharged-patients-icon.542eb3efa8c378a22c96355adb9b0302.svg";
export { ForwardRef as ReactComponent };